import type { PriceBreakdownViewState } from "@slfinrtl/ui-bff-routes"
import { getPriceBreakdownRoute, ShowLuxuryTaxType, SpareWheelType } from "@slfinrtl/ui-bff-routes"
import { useEffect, useState } from "react"
import { useFormContext } from "react-hook-form"
import type { InventoryInformationFormValues } from "src/components"
import { useBffDynamic, useJsonMemorizedValue, useRequestQueueWrapper } from "src/hooks"

export const usePriceBreakdown = (inventoryId: string) => {
	const [priceBreakdown, setPriceBreakdown] = useState<PriceBreakdownViewState | undefined>()
	const { watch } = useFormContext<InventoryInformationFormValues>()

	const fetchPriceBreakdown = useRequestQueueWrapper(useBffDynamic(getPriceBreakdownRoute, "inline"), undefined)

	const vehiclePrice = watch("vehiclePrice")
	const showLuxuryTax = watch("showLuxuryTax")
	const hasSpareWheel = watch("hasSpareWheel")
	const accessoryIds = useJsonMemorizedValue(watch("accessoryIds"))

	useEffect(() => {
		async function updatePriceBreakdown() {
			if (
				vehiclePrice !== undefined &&
				vehiclePrice !== null &&
				showLuxuryTax !== undefined &&
				hasSpareWheel !== undefined
			) {
				setPriceBreakdown((oldPriceBreakdown) =>
					oldPriceBreakdown?.state !== "complete"
						? oldPriceBreakdown
						: {
								lastPriceBreakdown: oldPriceBreakdown.priceBreakdown,
								state: "loading",
							},
				)
				try {
					const newPriceBreakdown = await fetchPriceBreakdown({
						body: {
							accessories: accessoryIds,
							luxuryTaxIncluded: showLuxuryTax === ShowLuxuryTaxType.YES,
							numberOfTires: hasSpareWheel === SpareWheelType.YES ? 5 : 4,
							vehiclePrice,
						},
						pathParams: {
							inventoryId,
						},
						queryParams: {},
					})
					// TODO: can this ever be undefined?
					if (newPriceBreakdown) {
						setPriceBreakdown({ priceBreakdown: newPriceBreakdown, state: "complete" })
					}
				} catch {
					setPriceBreakdown({ state: "error" })
				}
			} else {
				setPriceBreakdown(undefined)
			}
		}

		void updatePriceBreakdown()
	}, [vehiclePrice, showLuxuryTax, hasSpareWheel, accessoryIds, fetchPriceBreakdown, inventoryId])

	return priceBreakdown
}
